import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import AIVoiceCloningList from "./AIVoiceCloningList";
import VoiceCloningChat from "./VoiceCloningChat";

const VoiceCloningContainer = () => {
    const { modelId } = useParams();
    const navigate = useNavigate();

    const handleModelSelect = (selectedModelId) => {
        navigate(`chat/${selectedModelId}`);
    };

    const handleBack = () => {
        navigate("/voice-cloning");
    };

    return (
        <div>
            {!modelId ? (
                <AIVoiceCloningList onModelSelect={handleModelSelect} />
            ) : (
                <VoiceCloningChat modelId={modelId} onBack={handleBack} />
            )}
        </div>
    );
};

export default VoiceCloningContainer;
